import {
  setDebug,
  themeParams,
  initData,
  viewport,
  init as initSDK,
  miniApp,
  backButton,
  swipeBehavior,
} from '@tma.js/sdk-react';

interface InitOptions {
  debug: boolean;
  /** Load Eruda mobile dev console (iOS/Android only, dev builds only) */
  eruda?: boolean;
  /** reserved — Telegram-for-macOS theme workaround can be added later if needed */
  mockForMacOS?: boolean;
}

/**
 * Initializes the Telegram SDK and mounts all components used by the app.
 * Mirrors the official @tma.js/sdk-react template init flow.
 */
export async function initTelegram(options: InitOptions): Promise<void> {
  setDebug(options.debug);
  initSDK();

  if (options.eruda) {
    try {
      const { default: eruda } = await import('eruda');
      eruda.init();
      console.info('[telegram] Eruda dev console initialized');
    } catch (err) {
      console.warn('[telegram] failed to init Eruda:', err);
    }
  }

  backButton.mount.ifAvailable();
  initData.restore();

  if (miniApp.mount.isAvailable()) {
    themeParams.mount();
    miniApp.mount();
    themeParams.bindCssVars();
  }

  // Expand the WebView to full height + lock the vertical swipe-to-close
  // gesture. Without disableVertical(), pulling down inside scrollable
  // content can dismiss the Mini App by mistake (Bot API 7.7+; older
  // clients silently no-op).
  if (viewport.mount.isAvailable()) {
    void viewport.mount().then(() => {
      viewport.bindCssVars();
      if (viewport.expand.isAvailable()) viewport.expand();
    });
  }

  if (swipeBehavior.mount.isAvailable()) {
    swipeBehavior.mount();
    if (swipeBehavior.disableVertical.isAvailable()) {
      swipeBehavior.disableVertical();
    }
  }
}
